import { apiClient } from '../api-client'

export interface MetadataOption {
  value: string
  label: string
}

interface MetadataListResponse {
  items: MetadataOption[]
}

export const metadataApi = {
  getProjectTypes: async (): Promise<MetadataOption[]> => {
    const response = await apiClient.get<MetadataListResponse>('/metadata/project-types')
    return response.items || []
  },

  getDepartments: async (): Promise<MetadataOption[]> => {
    const response = await apiClient.get<MetadataListResponse>('/metadata/departments')
    return response.items || []
  },
}

